import { createEventListener } from "../../utils/events/trackComponent";
import { trackGAEvents } from "../../utils/events/ga";

const shareButton = document.querySelectorAll(".js-share-open-popover");
const label = window.location.href;

if (shareButton) {
  shareButton.forEach((elem) => {
    createEventListener(elem, () => {
      trackGAEvents("Share", "open-share", label)
    });
  });
}
